export type AdminRole = "support" | "moderator" | "superadmin" | "analyst";

export interface AdminIdentity {
  id: string;
  email: string | undefined;
  role: AdminRole;
}

export type BffError = {
  code: string;
  message: string;
  details?: Array<{ field: string; issue: string }>;
  traceId: string;
};

export type BffEnvelope<T> =
  | { data: T; error: null }
  | { data: null; error: BffError };

export const ROLE_HOME: Record<AdminRole, string> = {
  support: "/users",
  superadmin: "/users",
  analyst: "/dashboard",
  moderator: "/moderation",
};
